import React from "react";
import CommentChange from "../components/postComments/CommentChange";

const PostCommentUpdata = () => {
  return (
    <div>
      <CommentChange />
    </div>
  );
};

export default PostCommentUpdata;
